/**
 * Whether to evaluate hCaptcha scores on frontend and backend. Should not block requests, even if enabled.
 */ export var ENABLE_HCAPTCHA_INTEGRATION_221129 = 'ENABLE_HCAPTCHA_INTEGRATION_221129';
